import { render, staticRenderFns } from "./SubjectAnalysis.vue?vue&type=template&id=0de801c0&scoped=true"
import script from "./SubjectAnalysis.vue?vue&type=script&lang=js"
export * from "./SubjectAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de801c0",
  null
  
)

export default component.exports